<template>
    <div class="layer-node-container" :data-exec-mode="execMode">

        <!-- Modo visualização -->
        <template v-if="execMode == gConsts.rt.execModes.VIEW">
            <div class="layer-node-header">
                <span class="layer-node-title">{{ node.report.text || node.layout.caption }}</span>
            </div>
            <div class="layer-node-content">
                <section class="layer-node-children">
                    <labelNodeCMP v-for="(child, index) in children" 
                        :key="child.id" :node="child" :execMode="execMode"
                        :reportNode="childrenReportNodes[index]" 
                        :id="child.id" :active="activeNode ? activeNode?.label == child.id : false">
                    </labelNodeCMP>
                </section>
            </div>
        </template>

        <!-- Modo de edição (WORK) -->
        <template v-if="execMode == gConsts.rt.execModes.WORK">
            <expansionPanelUI @onExpandedChange="toggleActive" :expanded="isActive" class="layer-node-expansion-panel" borderRadius="8">
                <template #header>
                    <div class="layer-node-header">
                        <span class="layer-node-title">{{ node.layout.caption }}</span>
                    </div>
                </template>
                <template #content>

                    <section class="layer-node-children">
                        <labelNodeCMP v-for="(child, index) in children" 
                            :key="child.id" :node="child" :execMode="execMode"
                            :reportNode="childrenReportNodes[index]" 
                            :id="child.id" :active="activeNode ? activeNode?.label == child.id : false">
                        </labelNodeCMP>
                    </section>
                </template>
            </expansionPanelUI>
        </template>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import expansionPanelUI from '@/components/ui/expansionPanel.vue';
import labelNodeCMP from './labelNode.vue';

import { gConsts } from '@/globals/gConsts';
import { evtBus } from '@/main';

export default {
    name: 'layerNodeCMP',
    components: {
        expansionPanelUI,
        labelNodeCMP
    },
    props: {
        execMode: {
            type: String,
            default: gConsts.rt.execModes.WORK
        },
        node: {
            type: Object,
            required: true
        },
        id: {
            type: String,
            required: true
        },
        activeNode: {
            type: Object,
            default: null
        }
    },

    data() {
        return {
            gConsts: gConsts,
            isActive: this.activeNode != null,
        }
    },

    methods: {
        toggleActive() {
            this.isActive = !this.isActive;

            evtBus.$emit('evt_relatorioDinamico_activateNode', { nodeId: this.id, nodeType: gConsts.node.layout.types.LAYER });
        }
    },

    watch: {
        activeNode(newVal) {
            this.isActive = newVal != null;
        }
    },

    computed: {
        ...mapGetters([
            'GET_filteredNodes',
            'GET_reportNodes'
        ]),

        children() { 
            return this.GET_filteredNodes.filter(node => (node.layout.parent === this.node.id));
        },

        childrenReportNodes() {
            return this.children.map(child => this.GET_reportNodes.find(reportNode => reportNode.id === child.id));
        }
    }
}
</script>

<style scoped>

/* Modo visualização */

.layer-node-container[data-exec-mode="view"] {
    padding: 5px 10px;
    display: flex;
    flex-direction: column;
    gap: 5px;
}

.layer-node-container[data-exec-mode="view"] .layer-node-title {
    color: #434D5C;
    letter-spacing: 0.5px;
}

.layer-node-container[data-exec-mode="view"] .layer-node-children {
    gap: 0;
}


/* Modo de edição (WORK) */

.layer-node-expansion-panel {
    box-shadow: 0px 1px 2px 0px #0000000D;
}

.layer-node-header {
    display: flex;
    align-items: center;
    gap: 10px;
    width: 100%;
}

.expansion-panel-header[data-expanded="true"] .layer-node-title {
    color: #2B536A;
}

.layer-node-title {
    font-family: var(--font-family-primary);
    font-weight: 600;
    font-size: var(--text-md);
    color: #475569;
}

.layer-node-children {
    display: flex;
    flex-direction: column;
    gap: 5px;
}
</style>